function formatFakeAccuracy() {
    return {
        title: "Acuracidade",
        value: "94%",
        // subtitle: currencyFormatter.format(NetAmount),
    };
}

export default formatFakeAccuracy;
